import './styles/HomeRecipes.css'
import {IMAGE_URL} from "../../path";
import {Link} from "react-router-dom";
import {useNavigate} from "react-router-dom";
type Props = {
    recipes_blurb: string,
    featured_recipes: {
        name: string;
        slug: string;
        featured_image: string;
        preparation_time: string;
        cooking_time: string;
        servings: string;
        product_slug: string;
        occasion: string;
    }[];
    cuisine_image: string;
    product_image: string;
}

function HomeRecipeSection(props: Props) {
    const navigate = useNavigate();
    return (
        <div className="recipe-section">
            <div className="recipe-heading">
                <h1>Let’s Cook</h1>
                <h2>Quick & Easy-to-Prep meals</h2>
            </div>
            <div className="lets-cook">
                <div className="lets-cook-section">
                    <img src={`${IMAGE_URL}${props.product_image}`} alt={"Cook by Product"}/>
                    <button type="button" onClick={() => {navigate('lets-cook/by-product')} }><p className="main">Let's Cook</p><p className="sub">by Product</p></button>
                </div>
                <div className="lets-cook-section">
                    <img src={`${IMAGE_URL}${props.cuisine_image}`} alt={"Cook by Cuisine"}/>
                    <button type="button" onClick={() => {navigate('lets-cook/by-cuisine')} }><p className="main">Let's Cook</p><p className="sub">by Cuisine</p></button>
                </div>
            </div>
            <div className="featured-recipes">
                <div className="recipe-copy">
                    <h1>New Recipes</h1>
                    <h2>Simple Recipes. Big Flavour.</h2>
                    <p>{props.recipes_blurb}</p>
                    <Link to="/recipes" className="view-all-button">
                        View all recipes
                    </Link>
                </div>
                <div className="featured">
                    {props.featured_recipes.map((recipe, index) => (
                        <div className="featured-recipe" key={index}>
                            <a href={"/recipe/" + recipe.slug}>
                                <img
                                    className="recipe-image"
                                    src={`${IMAGE_URL}${recipe.featured_image}`}
                                    alt={recipe.slug}
                                />
                            </a>

                            <div className="recipe-description">
                                <div className="recipe-description-inner">
                                    <span className="recipe-tag">{recipe.occasion}</span>
                                    <div className="recipe-name">{recipe.name}</div>
                                    <div className="home-recipe-icons">
                                        <div className="recipe-icon">
                                            <div className="icon">
                                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                                                    <path id="Path_14082" data-name="Path 14082" d="M38.04,20.5h-3.1a.492.492,0,1,1,0-.984h3.1a.492.492,0,1,1,0,.984m-2,8.77a.487.487,0,0,1-.67.178L32.679,27.9a.49.49,0,1,1,.492-.848L35.86,28.6a.487.487,0,0,1,.178.67M29.455,4.631,27.9,7.32a.49.49,0,0,1-.848-.492l1.552-2.689a.49.49,0,0,1,.848.492m-.2,31.416a.494.494,0,0,1-.67-.178l-1.552-2.689a.487.487,0,0,1,.178-.67.494.494,0,0,1,.67.178l1.552,2.689a.489.489,0,0,1-.178.67M20.013,21.917a1.9,1.9,0,0,1-.492-3.732V7.71a.492.492,0,0,1,.984,0V18.185a1.916,1.916,0,0,1,1.349,1.349H28.7a.508.508,0,0,1,0,.984H21.854a1.894,1.894,0,0,1-1.832,1.408m.45,16.107a.492.492,0,0,1-.984,0v-3.1a.492.492,0,0,1,.984,0ZM12.793,7.481a.494.494,0,0,1-.67-.178L10.571,4.614a.487.487,0,0,1,.178-.67.494.494,0,0,1,.67.178l1.552,2.689a.489.489,0,0,1-.178.67m.153,25.683-1.552,2.689a.49.49,0,0,1-.848-.492L12.1,32.672a.49.49,0,0,1,.848.492M7.5,12.765a.487.487,0,0,1-.67.178L4.14,11.391a.49.49,0,1,1,.492-.848l2.689,1.552a.487.487,0,0,1,.178.67M7.3,27.871,4.615,29.423a.49.49,0,1,1-.492-.848l2.689-1.552a.494.494,0,0,1,.67.178.487.487,0,0,1-.178.67M1.468,19.983a.492.492,0,0,1,.492-.492h3.1a.492.492,0,1,1,0,.984H1.96a.492.492,0,0,1-.492-.492M19.529,1.959a.492.492,0,0,1,.984,0v3.1a.492.492,0,0,1-.984,0v-3.1ZM32.7,12.12l2.689-1.552a.494.494,0,0,1,.67.178.487.487,0,0,1-.178.67l-2.689,1.552a.494.494,0,0,1-.67-.178.487.487,0,0,1,.178-.67M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0" fill="#fff"/>
                                                </svg>
                                            </div>
                                            <div className="info">
                                                {recipe.preparation_time}
                                            </div>
                                        </div>
                                        <div className="recipe-icon">
                                            <div className="icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="32.995" viewBox="0 0 50 32.995">
                                                    <g id="Layer_1" data-name="Layer 1">
                                                        <g id="Group_827" data-name="Group 827" >
                                                            <path id="Path_14079" data-name="Path 14079" d="M49.028,11.286a2.092,2.092,0,0,0-2.92.608,1.157,1.157,0,0,1-.928.591c-.836.127-1.671.287-2.524.43-.008-.219-.017-.405-.034-.633H7.418c-.017.228-.025.422-.042.658-1.055-.194-2.076-.371-3.089-.574-.1-.017-.186-.16-.245-.262A2.146,2.146,0,0,0,1.721,10.99,2.069,2.069,0,0,0,0,13.244a1.935,1.935,0,0,0,1.975,1.747,1.324,1.324,0,0,1,.312.042c1.511.329,3.022.658,4.524,1,.641.143.557,0,.557.675V27.955A6.7,6.7,0,0,0,14.145,34.7c7.25-.084,14.509-.025,21.759-.025a6.729,6.729,0,0,0,6.718-6.71V16.156c.177-.042.312-.084.456-.118,1.35-.3,2.7-.591,4.06-.878a4.139,4.139,0,0,1,.9-.16,1.883,1.883,0,0,0,1.637-.912,2.023,2.023,0,0,0-.658-2.794Z" transform="translate(0.008 -1.704)" fill="#fff"/>
                                                            <path id="Path_14080" data-name="Path 14080" d="M43.977,9.233a2.173,2.173,0,0,0-.3-1.418,3.251,3.251,0,0,0-1.629-1.3A31.081,31.081,0,0,0,34.2,4.574c-.937-.127-1.874-.228-2.8-.338A4.967,4.967,0,0,0,26.539,0,4.941,4.941,0,0,0,21.323,4.27c-.059.4-.971.321-1.241.321a17.588,17.588,0,0,0-4.034.49c-1.325.287-2.65.608-3.958.971l-.523.152A5.172,5.172,0,0,0,9.49,7.292a2.131,2.131,0,0,0-.734,1.95H43.969Zm-17.53-6.9a2.245,2.245,0,0,1,2.186,1.764H24.125a2.164,2.164,0,0,1,2.321-1.764Z" transform="translate(-1.355 0.002)" fill="#fff"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div className="info">
                                                {recipe.cooking_time}
                                            </div>
                                        </div>
                                        <div className="recipe-icon">
                                            <div className="icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="41" viewBox="0 0 50 41">
                                                    <g id="Layer_1" data-name="Layer 1" transform="translate(0 0.008)">
                                                        <path id="Path_14081" data-name="Path 14081" d="M45.1,12.855a15.626,15.626,0,0,0-2.415-.992c-.572.5-1.173,1.021-1.784,1.542,3.6.982,4.456,1.994,4.456,2.3,0,.344-1.075,1.571-5.846,2.642a58.4,58.4,0,0,1-7.414,1.1L46.651,6.816c2.632-2.278,4.111-5.3,2.948-6.433s-4.3.3-6.655,2.848l-15.32,16.5c-1.282.049-2.583.079-3.914.079a75.891,75.891,0,0,1-15.8-1.463c-4.772-1.07-5.846-2.3-5.846-2.642s1.075-1.562,5.846-2.642A75.891,75.891,0,0,1,23.71,11.6a90.832,90.832,0,0,1,9.385.462c.562-.609,1.124-1.208,1.676-1.807A91.966,91.966,0,0,0,23.71,9.615,77.587,77.587,0,0,0,7.443,11.137a21.451,21.451,0,0,0-5.126,1.719C.779,13.671,0,14.633,0,15.713a2.676,2.676,0,0,0,.059.491c0-.01-.01-.02-.01-.029A22.8,22.8,0,0,0,12.3,35.434h-.02v2.318c0,1.787,5.117,3.241,11.426,3.241s11.426-1.453,11.426-3.241V35.434h-.02A22.8,22.8,0,0,0,47.37,16.175a.036.036,0,0,1-.01.029,2.09,2.09,0,0,0,.059-.491c0-1.08-.779-2.033-2.317-2.858Z" transform="translate(0 0)" fill="#fff"/>
                                                    </g>
                                                </svg>

                                            </div>
                                            <div className="info">
                                                {recipe.servings}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <Link
                                to={`/recipe/${recipe.slug}`}
                                className="buy-now-button"
                            >
                                View Recipe
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default HomeRecipeSection;
